"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const StyledMenuList = styled_1.default.ul({
    'borderRadius': '6px',
    'boxShadow': '0 10px 24px 0 rgba(155,165,177,0.2)',
    'boxSizing': 'border-box',
    'listStyleType': 'none',
    'marginBottom': 0,
    'marginLeft': 0,
    'marginRight': 0,
    'marginTop': 9,
    'outlineStyle': 'solid',
    'outlineWidth': 1,
    'overflowY': 'scroll',
    'paddingBottom': 9,
    'paddingLeft': 18,
    'paddingRight': 0,
    'paddingTop': 9,
    'position': 'absolute',
    'width': '100%',
    'zIndex': 1,
    '&::-webkit-scrollbar': {
        width: 19
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundClip: 'padding-box',
        borderRadius: 10,
        borderWidth: 6,
        borderStyle: 'solid'
    },
    '&::-webkit-scrollbar-track': {
        borderRadius: 6
    },
    '@-moz-document url-prefix()': {
        paddingRight: 18
    }
}, ({ maxHeight, theme }) => ({
    'backgroundColor': theme.palette.colors.lotion,
    'maxHeight': maxHeight,
    'outlineColor': theme.palette.colors.solitude2,
    '&::-webkit-scrollbar-thumb': {
        borderColor: theme.palette.colors.lotion,
        backgroundColor: theme.palette.colors.columbiaBlue
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: theme.palette.colors.lotion
    }
}));
exports.default = StyledMenuList;
//# sourceMappingURL=StyledMenuList.js.map